// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  userInfo: null,
  isPayrollApprover: false,
  accessToken: null,
  abilities: [],
  userPermission: [],
  myTrainingInfos: [],
  myProjects: [],
  myTrainers: [],
  projectData: [],
  salesProjects: ["WW"],
  salesInstitutes: [],
  currentSelectedModule: null,
  assignedEmployees: [],
  assignedEmployeesUserUid: [],
  assignedEmployeesR1: [],
  assignedEmployeesR1UserUid: [],
  assignedEmployeesR2: [],
  assignedEmployeesR2UserUid: [],
};

// Redux Slice for Logged in user
const loggedInUserInfoSlice = createSlice({
  name: "loggedInUserInfo",
  initialState,
  reducers: {
    setUserInfo(state, { payload }) {
      console.log("####", payload);
      if (state.userInfo?.uid !== payload?.uid ||
          state.userInfo?.employeeProfile?.uid !== payload?.employeeProfile?.uid) {
        state.isPayrollApprover = false;
      }
      state.userInfo = payload;
    },
    setIsPayrollApprover(state, { payload }) {
      state.isPayrollApprover = Boolean(payload);
    },
    setAccessToken(state, { payload }) {
      state.accessToken = payload;
    },
    removeAccessToken(state) {
      state.accessToken = null;
    },
    setAbilities(state, { payload }) {
      state.abilities = payload;
    },
    setUserPermission(state, { payload }) {
      state.userPermission = payload;
    },
    setUpdatedUserInfo(state, { payload }) {
      state.userInfo = {
        ...state.userInfo,
        name: payload.name,
        designation: payload.designation,
        email: payload.email,
        contact_details: payload.contact_details,
        gender: payload.gender,
      };
    },
    setMyTrainingInfos(state, { payload }) {
      state.myTrainingInfos = payload;
    },
    setMyProjects(state, { payload }) {
      state.myProjects = payload;
    },
    setMyTrainers(state, { payload }) {
      state.myTrainers = payload;
    },
    setProjectData(state, { payload }) {
      state.projectData = payload;
    },
    setSalesInstitutes(state, { payload }) {
      return {
        ...state,
        salesInstitutes: payload,
      };
    },
    setCurrentSelectedModule(state, { payload }) {
      state.currentSelectedModule = payload;
    },
    setAssignedEmployees(state, { payload }) {
      state.assignedEmployees = payload;
    },
    setAssignedEmployeesUserUid(state, { payload }) {
      state.assignedEmployeesUserUid = payload;
    },
    setAssignedEmployeesR1(state, { payload }) {
      state.assignedEmployeesR1 = payload;
    },
    setAssignedEmployeesR1UserUid(state, { payload }) {
      state.assignedEmployeesR1UserUid = payload;
    },
    setAssignedEmployeesR2(state, { payload }) {
      state.assignedEmployeesR2 = payload;
    },
    setAssignedEmployeesR2UserUid(state, { payload }) {
      state.assignedEmployeesR2UserUid = payload;
    },
  },
});

export const loggedInUserInfoSliceActions = loggedInUserInfoSlice.actions;

export default loggedInUserInfoSlice;
